module.exports = __webpack_public_path__ + "img/house-chimney-blank.f2b49447.svg";